var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClinic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4333F",
    d: "M20.7 10.35c0 5.716-4.634 10.35-10.35 10.35C4.634 20.7 0 16.066 0 10.35 0 4.634 4.634 0 10.35 0 16.066 0 20.7 4.634 20.7 10.35",
    transform: "translate(.137 .431)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D99EBA",
    d: "M0 10.35C0 16.066 4.634 20.7 10.35 20.7c5.716 0 10.35-4.634 10.35-10.35H0z",
    transform: "translate(.137 .431)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDE3E3",
    d: "M12.2 5.563c0-1.022-.83-1.851-1.852-1.851-1.023 0-1.852.83-1.852 1.853l.003 9.572c0 1.023.83 1.852 1.853 1.852 1.023-.001 1.852-.831 1.851-1.854l-.002-9.572z",
    transform: "translate(.137 .431)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EDE3E3",
    d: "M15.137 12.2c1.023 0 1.851-.829 1.851-1.852 0-1.023-.83-1.852-1.853-1.852L5.563 8.5c-1.023.001-1.851.83-1.851 1.853 0 1.023.83 1.851 1.853 1.851l9.572-.002z",
    transform: "translate(.137 .431)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClinic);
export default __webpack_public_path__ + "static/media/clinic.21d36bf159f0a427aca9189ca2be6cea.svg";
export { ForwardRef as ReactComponent };